<!-- Angular projects default content into one slot only, so both layouts render the same template -->
<ng-template #content>
    <ng-content></ng-content>
</ng-template>

@if (layout() === 'split') {
    <div class="intro">
        <div class="head">
            @if (icon()) {
                <app-icon-tile [icon]="icon()"></app-icon-tile>
            }
            <h2>{{ title() }}</h2>
        </div>
        @if (description()) {
            <p>{{ description() }}</p>
        }
        <ng-content select="[intro]"></ng-content>
    </div>
    <div class="body fields">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
    </div>
} @else {
    <div class="head">
        @if (icon()) {
            <app-icon-tile [icon]="icon()"></app-icon-tile>
        }
        <div class="titles">
            <h2>
                {{ title() }}
                @if (meta() !== null && meta() !== undefined) {
                    <span class="meta">{{ meta() }}</span>
                }
            </h2>
            @if (subtitle()) {
                <span class="subtitle">{{ subtitle() }}</span>
            }
        </div>
        <div class="actions">
            <ng-content select="[actions]"></ng-content>
        </div>
    </div>
    <div class="body">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
    </div>
}
